export default function (date) {
	let iso = new Date(date);
	iso.setHours(iso.getHours() - iso.getTimezoneOffset() / 60);
	return iso.toISOString();
}
